import { createAction } from 'redux-actions';

export const setDisplayOptionAction = createAction(
  'SET_STATEMENT_SUMMARY_DISPLAY_OPTION',
);

export const setIsComfortLetterEnabledAction = createAction(
  'SET_COMFORT_LETTER_ENABLED_FILTER_OPTION',
);
